import { InjectionToken } from '@angular/core';
import { SocialUser } from 'angularx-social-login';

import { UserServiceConfig } from '@relevance/angular-core';
import { IUser, IProfile } from '@relevance/core';

/**
 * Interface for the search service configuration.
 */
export interface AccountServiceConfig {
  userConfig: UserServiceConfig;
  redirectPath?: string;
  storageEngine?: 'sessionStorage'|'localStorage';
  storagePrefix?: string;
  facebookId?: string;
  googleId?: string;
}

/**
 * This injection token can be used to inject the account configuration.
 */
export const ACCOUNT_CONFIG = new InjectionToken<AccountServiceConfig>('AccountServiceConfig');

/**
 * This factory provides the anonymous user object.
 */
export type AnonymousUserFactory<U extends IUser> = () => U;

/**
 * This injection token can be used to inject the query API c
 */
export const ANONYMOUS_USER = new InjectionToken<AnonymousUserFactory<any>>('AnonymousUserFactory');

/**
 * This factory provides a profile object based on a social user object.
 */
export type SocialUserProfileFactory<P extends IProfile> = (socialUser: SocialUser) => P;

/**
 * This injection token can be used to inject the query API c
 */
export const SOCIAL_USER_PROFILE = new InjectionToken<SocialUserProfileFactory<any>>('AnonymousUserFactory');
